import type React from 'react';

import { Helmet } from 'react-helmet-async';

import { usePageMeta } from './hooks/usePageMeta';

export const PageMeta: React.FC = () => {
	const {
		data: { title, description, image },
	} = usePageMeta();

	return (
		<Helmet>
			<title>{title}</title>
			<meta property="og:type" content="website" />
			<meta name="twitter:card" content="summary" />
			<meta property="og:title" content={title} />
			<meta property="og:description" content={description} />
			<meta property="description" content={description} />
			<meta property="og:image" content={image} />
			<meta property="twitter:image" content={image} />
			<meta property="twitter:image:alt" content={title} />
		</Helmet>
	);
};
